import { useEffect } from "react";
import keywordsClasses from "venuescanner-js/react/components/Srp/components/Filters/FilterOptions/keywords.module.scss";

// TODO: Remove keywordsClasses from here

export default function useClickElsewhere(excludedRefs, fn, isActive) {
  useEffect(() => {
    if (typeof document === "undefined") return;

    const remove = () => {
      // console.log('removed handleClickElseWhere')
      document.removeEventListener("click", handleClickElseWhere);
    };
    if (!isActive) return remove();

    function handleClickElseWhere(e) {
      if (
        excludedRefs.some(
          (ref) => !ref.current || ref.current.contains(e.target)
        )
      )
        return;
      if (e.target === document.body) return;
      if (
        typeof e.target.className.includes === "function" &&
        e.target.className.includes(keywordsClasses.Keyword)
      )
        return;
      if (document.querySelector(".DateRangePicker_picker")?.contains(e.target))
        return;

      if (fn) fn(e);

      // console.log('handleClickElseWhere')
      remove();
    }
    setTimeout(() => {
      document.addEventListener("click", handleClickElseWhere);
    });

    return remove;
  }, [
    // excludedRefs,
    // fn,
    isActive,
  ]);
}
